import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAbsolvedCheckAbility } from '../../hooks/useAbsolvedCheckAbility';
import ChecksList from '../checks/ChecksList';
import { useTranslation } from 'react-i18next';

const OrgChecksPage: React.FC = () => {
  const ability = useAbsolvedCheckAbility();
  const { t } = useTranslation();
  if (ability.cannot('read', 'AbsolvedCheck')) {
    return <Navigate to='/' />;
  }

  return (
    <>
      <h2>{t('pages.orgChecks.title')}</h2>

      <ChecksList variant='org' />
    </>
  );
};

export default OrgChecksPage;
